import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Comparative from "@/components/site/Comparative";
import HowItWorks from "@/components/site/HowItWorks";
import PricingTeaser from "@/components/site/PricingTeaser";
import Universities from "@/components/site/Universities";
import SiteFooter from "@/components/site/SiteFooter";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-paper text-ink font-sans selection:bg-forest selection:text-paper"
    >
      <Navbar />
      <Hero />
      <Comparative />
      <HowItWorks />
      <Universities />
      <PricingTeaser />

      {/* Discreet admin access link — right below the pricing section */}
      <section
        aria-label="Acceso administrador"
        className="border-t border-rule/40 bg-paper"
      >
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-6 flex items-center justify-center">
          <Link
            to="/superadmin/login"
            data-testid="hero-superadmin-link"
            className="inline-flex items-center gap-1.5 text-[11px] tracking-[0.18em] uppercase text-ink-soft/55 hover:text-copper transition-colors font-medium"
          >
            <Lock size={10} /> Acceso Admin · Operaciones internas
          </Link>
        </div>
      </section>

      <SiteFooter />
    </main>
  );
}
